"use client"

import { useEffect, useState } from 'react'

const HOST = process.env.NEXT_PUBLIC_HOST
const MARKER = /(?:^|;\s*)spl_panel_link=1(?:;|$)/

export function casesLabel (n) {
    const few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)
    return `${n} ${n === 1 ? 'sprawa' : few ? 'sprawy' : 'spraw'}`
}

export const panelLink = { key: 'panel', t: 'Panel administratora', href: HOST + '/panel', group: 'panel' }

// Link do panelu tylko w przeglądarce (znacznik ustawiany przy logowaniu administratora); HTML z serwera go nie zawiera.
// Licznik spraw otwartych — raz po wejściu na stronę, tylko przy ważnej sesji panelu (bez sesji: link bez licznika).
export function usePanelLink (isLoggedIn) {
    const [marked, setMarked] = useState(false)
    const [count, setCount] = useState(0)

    useEffect(() => {
        setMarked(Boolean(isLoggedIn) && MARKER.test(document.cookie))
    }, [isLoggedIn])

    useEffect(() => {
        if (!marked) return
        let alive = true
        fetch('/api/panel/liczniki', { credentials: 'same-origin', cache: 'no-store' })
            .then(res => res.ok ? res.json() : null)
            .then(data => {
                const c = data?.counters
                if (alive && c) setCount((c.naruszenia || 0) + (c.czat || 0) + (c.nip || 0))
            })
            .catch(() => null)
        return () => { alive = false }
    }, [marked])

    return marked ? { ...panelLink, count } : null
}
